module.exports = __webpack_public_path__ + "img/bg-download-section-1.63b3ef65.jpg";